var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 702,
    height: 509,
    viewBox: "0 0 704 510",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.412 74.4084L268.859 73.278L262.991 78.2517L264.12 85.7123L259.155 79.8343L251.708 80.7386L257.575 75.9909L256.447 68.3042L261.412 74.4084Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178.77 179.016L183.734 184.668L176.513 182.407L170.871 187.607L172.902 180.372L167.938 174.494L175.159 176.755L181.026 171.555L178.77 179.016Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M648.906 26.5378L656.128 29.0247L648.681 30.6072L645.973 37.8417L644.393 30.3811L637.172 27.8943L644.619 26.3117L647.327 19.0771L648.906 26.5378Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M532.353 99.9536L539.574 102.44L532.127 104.023L529.419 111.258L528.065 103.797L520.844 101.084L528.291 99.5014L530.773 92.2668L532.353 99.9536Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M422.341 26.5378L429.562 29.0247L422.115 30.6072L419.407 37.8417L418.053 30.3811L410.832 27.8943L418.279 26.3117L420.761 19.0771L422.341 26.5378Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M189.454 502.887L191.936 505.6L188.326 504.47L185.618 506.957L186.746 503.339L184.264 500.627L187.874 501.757L190.582 499.27L189.454 502.887Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M191.034 444.333L194.644 443.655L191.936 446.141L192.613 449.759L190.131 447.046L186.521 447.724L189.228 445.237L188.551 441.62L191.034 444.333Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M275.207 504.922L277.915 507.409L274.304 506.731L271.822 509.444L272.499 505.827L269.791 503.34L273.402 504.018L275.884 501.305L275.207 504.922Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M610.773 194.289L615.738 200.167L608.517 197.906L602.875 202.88L604.906 195.645L599.941 189.993L607.163 192.028L613.03 187.054L610.773 194.289Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M698.331 137.317L703.296 142.969L696.074 140.708L690.207 145.908L692.464 138.447L687.273 132.795L694.721 135.056L700.362 129.856L698.331 137.317Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0978 8.24685L20.7168 10.8659L12.6216 12.5326L10.0025 20.1516L8.33588 12.2945L0.716797 9.43733L8.57399 7.77067L11.4311 0.151611L13.0978 8.24685Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.508a8bf544ec8832c5eef66b8d252f61.svg";
export { ForwardRef as ReactComponent };